export const CHECK_NOTIFICATIONS_COMMAND_ID = 'check-notifications';
